export default {
	tooLongDescriptionError: "Field \"{0}\" cannot be longer than 255 characters.",
	accessControlHasChanges: "The access control has supplemented data on the scope of the application, which has not been added.",
	fieldIsRequiredError: "The field \"{0}\" is required.",
	retypePasswordError: "Incorrect retyped password.",

	permissionLevelRequiredError: "Field \"Authorization level\" is required.",
	addToIssue: "Add to issue",
	dataSets: "Data sets",
	businessProcesses: "Business processes",
	resource: "Resource",
	period: "Period",
	authorizationLevel: "Authorization level",
	currentAuthorizations: "Current authorizations",

	warningEmployeeChangeTitle: "User change to whom the application relates",
	warningEmployeeChangeText: "Are you sure you want to change to {0}. The entire scope will be removed.",
	selectEmployee: "Select employee",
	authorizationControlHasChanges: "The authorization control has supplemented data on the scope of the application, which has not been added.",

	editing: "Editing",
	copying: "Copying",
	copy: "Copy",
	accept: "Accept",
	reject: "Reject",

	selectApplication: "Select application",
	selectService: "Select service",
	selectDataSet: "Select data set",
	selectBusinessProcess: "Select business process",

	name: "Name",
	sapId: "SAP Id",
	hrId: "HR Id",
	applicationName: "Application name",
	type: "Type",
	status: "Status",
	city: "City",
	company: "Company",
	riskLevel: "Risk level",
	department: "Department",

	administrativeRole: "Administrative role",
	sensitiveData: "Sensitive data",
	reasonForProcessingSensitiveData: "The reason for processing sensitive data",
	acceptCheckboxLabel: "I have read and understood the above text",

	step: "Step",
	of: "of",
}